export enum IPublicEnumTransformStage {
  Render = 'render',
  Serilize = 'serilize',
  Save = 'save',
  Clone = 'clone',
  Init = 'init',
  Upgrade = 'upgrade',
}
/**
 * @deprecated use IPublicEnumTransformStage instead
 */
export enum TransformStage {
  Render = 'render',
  Serilize = 'serilize',
  Save = 'save',
  Clone = 'clone',
  Init = 'init',
  Upgrade = 'upgrade',
}
